import { CalendarMonth, PeopleAltOutlined } from "@mui/icons-material"
import { Checkbox, FormControlLabel, Typography } from "@mui/material"
import { AttendanceFilter } from "components/AgencySelect"
import { CurrentWorkCycleButton, DataViewFilterSurface, DateRangeFilterControls, Flex } from "components/common"
import { DateTime } from "luxon"

export type AttendanceFilterValue = {
  attendees: Attendee[]
  endDate: DateTime
  showChat: boolean
  showCheckins: boolean
  showFullTime: boolean
  showOvertime: boolean
  showPartTime: boolean
  showPersonalView: boolean
  startDate: DateTime
}

type Props = {
  onChange: (patch: Partial<AttendanceFilterValue>) => void
  onShiftPeriod: (delta: number) => void
  resultLabel: string
  value: AttendanceFilterValue
}

const AttendanceFilterPanel = ({ onChange, onShiftPeriod, resultLabel, value }: Props) => {
  return (
    <DataViewFilterSurface
      headerAction={<CurrentWorkCycleButton endDate={value.endDate} onChange={onChange} startDate={value.startDate} />}
      resultLabel={resultLabel}
    >
      <>
        <Flex alignItems="center" className="flex-wrap" gap={1.5}>
          <DateRangeFilterControls
            endDate={value.endDate}
            onChange={onChange}
            onShiftPeriod={onShiftPeriod}
            startDate={value.startDate}
          />
          {!value.showPersonalView && (
            <AttendanceFilter attendees={value.attendees} onChange={(attendees) => onChange({ attendees })} />
          )}
        </Flex>

        <Flex alignItems="center" className="flex-wrap" gap={2} justifyContent="space-between">
          <Flex alignItems="center" className="flex-wrap" gap={1.5}>
            <Flex alignItems="center" gap={0.75}>
              <CalendarMonth color="action" fontSize="small" />
              <Typography color="text.secondary" fontWeight={600} variant="body2">
                Hiển thị
              </Typography>
            </Flex>
            <FormControlLabel
              control={
                <Checkbox
                  checked={value.showCheckins}
                  onChange={(event) => onChange({ showCheckins: event.target.checked })}
                  size="small"
                />
              }
              label="Check-in/out"
              sx={{ m: 0 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={value.showOvertime}
                  onChange={(event) => onChange({ showOvertime: event.target.checked })}
                  size="small"
                />
              }
              label="OT/PT"
              sx={{ m: 0 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={value.showChat}
                  onChange={(event) => onChange({ showChat: event.target.checked })}
                  size="small"
                />
              }
              label="Trực chat"
              sx={{ m: 0 }}
            />
          </Flex>

          {!value.showPersonalView && (
            <Flex alignItems="center" className="flex-wrap" gap={1.5}>
              <Flex alignItems="center" gap={0.75}>
                <PeopleAltOutlined color="action" fontSize="small" />
                <Typography color="text.secondary" fontWeight={600} variant="body2">
                  Loại nhân viên
                </Typography>
              </Flex>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={value.showFullTime}
                    onChange={(event) => onChange({ showFullTime: event.target.checked })}
                    size="small"
                  />
                }
                label="Full time"
                sx={{ m: 0 }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={value.showPartTime}
                    onChange={(event) => onChange({ showPartTime: event.target.checked })}
                    size="small"
                  />
                }
                label="Part time"
                sx={{ m: 0 }}
              />
            </Flex>
          )}
        </Flex>
      </>
    </DataViewFilterSurface>
  )
}

export default AttendanceFilterPanel
